import React, { useContext, useState } from "react";
import { useCustomTheme } from "../../ThemeContext";
import { Box, ListItemText } from "@mui/material";
import Drawer from "@mui/material/Drawer";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { useAuth } from "../../Auth/AuthContext";
import { ChangeAllBucketsModalContext } from "../ChangeAllBuckets/ChangeAllBucketsModalContext";
import LogoutDialog from "./LogoutDialog";

const Settings = () => {
  const { currentUser, logout } = useAuth();

  // drawer behaviour
  const [openDrawer, setOpenDrawer] = useState(false);

  const handleOpenDrawer = () => {
    setOpenDrawer(true);
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  // logout dialog
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);

  const handleOpenLogoutDialog = () => {
    setOpenLogoutDialog(true);
  };

  const handleCloseLogoutDialog = () => {
    setOpenLogoutDialog(false);
  };

  // theme change
  const { selectedTheme, setSelectedTheme } = useCustomTheme();

  const handleChangeTheme = (event) => {
    setSelectedTheme(event.target.value);
    handleCloseDrawer();
  };

  // Bucket rename
  const { toggleChangeAllBucketsModal } = useContext(
    ChangeAllBucketsModalContext
  );

  return (
    <>
      <IconButton onClick={handleOpenDrawer}>
        <MenuRoundedIcon fontSize="small" />
      </IconButton>
      <Drawer open={openDrawer} onClose={handleCloseDrawer} anchor="left">
        <Box display="flex" flexDirection="column" height="100%">
          <MenuList>
            <Box pl={1} pb={2}>
              <IconButton onClick={handleCloseDrawer}>
                <CloseRoundedIcon fontSize="small" />
              </IconButton>
            </Box>

            {/* Rename Buckets */}
            <MenuItem
              onClick={() => {
                toggleChangeAllBucketsModal();
                handleCloseDrawer();
              }}
            >
              <ListItemIcon>
                <EditOutlinedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Rename Bucket" />
            </MenuItem>
          </MenuList>
          {/* Spacer component to push the bottom section to the bottom */}
          <Box flexGrow={1} />
          <MenuList>
            {/* Theme */}
            <MenuItem>
              <ListItemIcon>
                <DarkModeOutlinedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>
                <FormControl variant="standard">
                  <Select
                    labelId="theme-select-label"
                    value={selectedTheme}
                    onChange={handleChangeTheme}
                    label="Theme"
                  >
                    <MenuItem value="light">
                      <Typography variant="body1">Light</Typography>
                    </MenuItem>
                    <MenuItem value="dark">
                      <Typography variant="body1">Dark</Typography>
                    </MenuItem>
                    <MenuItem value="system">
                      <Typography variant="body1">System</Typography>
                    </MenuItem>
                  </Select>
                </FormControl>
              </ListItemText>
            </MenuItem>

            {/* Logout */}
            <MenuItem
              onClick={() => {
                handleOpenLogoutDialog();
                handleCloseDrawer();
              }}
            >
              <ListItemIcon>
                <LogoutRoundedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Logout"
                secondary={currentUser ? currentUser.email : "N/A"}
              />
            </MenuItem>
          </MenuList>
        </Box>
      </Drawer>

      <LogoutDialog
        open={openLogoutDialog}
        onClose={handleCloseLogoutDialog}
        onLogout={() => {
          logout();
          handleCloseLogoutDialog();
        }}
      />
    </>
  );
};

export default Settings;
